<template>
  <v-layout row wrap justify-center style="height:100%; background-color:#222">
    <v-flex v-if="category === 'Logic'">
      <logicPanel
        v-bind:currentNode="currentNode"
        v-bind:editor="editor"
        v-bind:diagramData="diagramData"
      ></logicPanel>
    </v-flex>
    <v-flex v-if="category === 'User'">
      <userPanel
        v-bind:currentNode="currentNode"
        v-bind:editor="editor"
      ></userPanel>
    </v-flex>
    <v-flex v-if="category === 'Chatbot'">
      <chatbotPanel
        v-bind:currentNode="currentNode"
        v-bind:editor="editor"
        v-bind:diagramData="diagramData"
      ></chatbotPanel>
    </v-flex>
  </v-layout>
</template>
<script>
import logicPanel from './logicPanel'
import userPanel from './userPanel'
import chatbotPanel from './chatbotPanel'

export default {
  props: ['category', 'currentNode', 'editor', 'diagramData'],
  components: {
    logicPanel,
    userPanel,
    chatbotPanel
  }
}
</script>



// WEBPACK FOOTER //
// src/components/story-edit-view/bottomPanel.vue